import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchManualPreadviceTransactionsApply = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'applyManualPreadviceTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    transactionIds: payload.params.transactionIds,
  });
};

export default apiFetchManualPreadviceTransactionsApply;
